module.exports = __webpack_public_path__ + "img/field_off.37a51a6d.svg";